import { useContext } from 'react';
import { CustomTableData } from "common";
import { Button, Tooltip } from '@mui/material'
import { AlertTriangle, DollarSign, Edit3, Info, Trash2, TrendingDown } from 'react-feather'
import { TooltipInformation } from 'common';
import TooltipAprobacion from 'common/TooltipAprobacion/TooltipAprobacion'

export const PaymentsTable = ({useFetchInit}) => {

  const {
    FetchData,
    Actions,
    globalStates,
    Helpers
  }= useFetchInit


  const {fetchAllVehiclePayments:{vehiclePayments}} = FetchData

  const {handleClickShowModal} = Actions

  const {getPreviousMonthDate, getCurrentDate,  calculateMora, enableButtonAbono, convertToFloat} = Helpers

  const fecha_actual = getCurrentDate();

  // const {data, deleteRecord, getDocumentRegistry} = useContext(VehicleAppliesContext);
  
  const columnConfig = [
    { field: "no_cuota", headerName: "NO. CUOTA", maxWidth: 130, minWidth: 130, filter: true },
    { field: "fecha_pago", headerName: "FECHA", maxWidth: 120, minWidth: 120, filter: true },
    { field: "cuota_niv", headerName: "CUOTA", maxWidth: 120, minWidth: 120, filter: true },
    { field: "seguro", headerName: "SEGURO", maxWidth: 120, minWidth: 120, filter: true },
    { field: "gps", headerName: "GPS", maxWidth: 120, minWidth: 120, filter: true },
    { field: "otros", headerName: "OTROS", maxWidth: 120, minWidth: 120, filter: true },
    { field: "intereses", headerName: "INTERESES", maxWidth: 130, minWidth: 130, filter: true, },
    { field: "amortizacion", headerName: "AMORTIZACION", maxWidth: 130, minWidth: 130, filter: true, },
    {
      field: "exoneracion", headerName: "EXONERACION", maxWidth: 150, minWidth: 150, filter: true,
      valueGetter: (params) =>
        convertToFloat(String(params.data?.exoneracion ?? 0)) +
        convertToFloat(String(params.data?.exoneracion_arrastre ?? 0)),
      cellRenderer: (params) => {
        const total = params.value || 0
        const noAplicada = convertToFloat(String(params.data?.exoneracion_no_aplicada ?? 0))
        if (total <= 0) return 'Q. 0.00'
        return (
          <>
            {`Q. ${total.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
            {noAplicada > 0 && (
              <Tooltip title={`Q. ${noAplicada.toFixed(2)} de esta exoneracion no se pudo aplicar: la mora disminuyo despues de aprobarla (pago, reversion o abono a capital)`}>
                <AlertTriangle size={16} color="#f0ad4e" style={{ marginLeft: 6, verticalAlign: 'middle' }} />
              </Tooltip>
            )}
          </>
        )
      },
    },
    { field: "mora_f", headerName: "MORA", maxWidth: 120, minWidth: 120, filter: true,},
    { field: "total_abonado", headerName: "ABONADO", maxWidth: 140, minWidth: 140, filter: true,},
    { field: "abono_capital", headerName: "A. CAPITAL", maxWidth: 140, minWidth: 140, filter: true,},
    { field: "cuota_pagar", headerName: "CUOTA TOTAL", maxWidth: 150, minWidth: 150, filter: true },
    { 
      field: "dias_atraso_totales_f", 
      headerName: "DIAS DE ATRASO", 
      maxWidth: 160, 
      minWidth: 160, 
      filter: true,
      cellClass: (params) => {
        if((params.value > 0)) return 'bg-danger'; 
        return 'bg-success';
      },
    },

     { field: "total_pagar_f", headerName: "TOTAL A PAGAR", maxWidth: 180, minWidth: 180, filter: true,
      cellRenderer: (params) =>{
        return  ( parseFloat(params.value) > 0) ? `Q. ${params.value}` : `Q. ${0}`   
      }, 
      cellClass: (params) => {
        if(parseFloat(params.value) > 0) return 'bg-danger';
        return 'bg-success';
      },
     },
    {
      headerName: "OPCIONES",
      minWidth: 440,
      cellRenderer: (params) => {

        const {  
          total_pagar_f, 
          fecha_pago,
          idpago,
          enable
        } = params.data

        return (
            <>
                <Button 
                    startIcon = { <DollarSign/>}
                    variant='contained'
                    size='small' 
                    color='success'
                    sx={{ marginRight: '8px' }}
                    onClick={() => handleClickShowModal('', 'Formulario de pago', 'deposits-section', {total_pagar_f, fecha_pago, idpago}, 'EDITABLE')} 
                    style={ { width: 170 } }
                    disabled={!enable}
                    >  
                    Agregar Pago
                </Button>

                <Button 
                    startIcon = { <Info/>}
                    variant='contained'
                    size='small' 
                    color='info'
                    sx={{ marginRight: '8px' }}
                    onClick={() => handleClickShowModal('', 'Depositos', 'deposits-table', {idpago, fecha_pago}, 'EDITABLE')} 
                    style={ { width: 170 } }
                    > 
                      Depositos
                </Button>

            </>
        )
      }
    },
  ];

  const gridOptions = {
    getRowStyle: (params) => {
      const fecha_inicial = getPreviousMonthDate(params.data.fecha_pago)
      if ((fecha_actual > fecha_inicial) && (fecha_actual <= params.data.fecha_pago))
        return { backgroundColor: '#D9D9D9' }; 
      
    }
  };

  return (
    <>
      <CustomTableData
        rowConfig={vehiclePayments}
        gridOptions={gridOptions}
        columnConfig={columnConfig} />
    </>
  );
};
